<template>
  <v-list-item-content>
    <v-list-item-title>
      주요 재배 작물과 재배 면적 ({{ orderNum }})
      <span class="asterisk">*</span>
    </v-list-item-title>
    <!-- :disabled="userData.farm.crops1.length > 0" -->
    <v-text-field
      solo
      required
      ref="refCrops"
      placeholder="재배 작물"
      :height="formHeight"
      v-model="corps"
      @click="openSelect('주요 재배 작물 선택', itemsCrop)"
      @input="openSelect('주요 재배 작물 선택', itemsCrop)"
    >
      <template v-slot:append>
        <v-btn
          x-small
          depressed
          rounded
          @click="openSelect('주요 재배 작물 선택', itemsCrop)"
        >
          선택</v-btn
        >
      </template>
    </v-text-field>
    <v-text-field
      placeholder="재배 면적"
      ref="refCropArea"
      solo
      :height="formHeight"
      required
      suffix="평"
      type="number"
      :rules="[cropAreaRules.min, cropAreaRules.max, cropAreaRules.check]"
      v-model="cropsArea"
      @input="$emit('inputText', $event, orderNum)"
      @keyup="checkInput"
    />
  </v-list-item-content>
</template>
<script>
const rulesService = require("@/utils/rules.js");
export default {
  props: {
    userData: {
      type: Object,
    },
    itemsCrop: {
      type: [Object, Array],
    },
    formHeight: {
      type: Number,
    },
    orderNum: {
      type: Number,
    },
    corps: {
      type: String,
    },
    prosCropsArea: {
      type: [Number, String],
    },
  },
  data() {
    return {
      cropsArea: "",
      cropAreaRules: rulesService.cropAreaRules(),
    };
  },
  watch: {
    prosCropsArea(val) {
      this.cropsArea = val;
    },
  },
  methods: {
    openSelect(title, items) {
      this.$emit("openSelect", title, items);
    },
    checkInput(e) {
      console.log("e", this.cropsArea.length);
      var charCode = e.which ? e.which : e.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        const msg = "재배 면적은 정수만 입력가능합니다";
        this.cropsArea = Number(this.cropsArea);
        this.$helper.showTostMessage("", msg, "error");
        return;
      }
      if (e.target.value.length > 8) {
        const msg = "재배 면적은 1000000 이상으로 입력할 수 없습니다.";
        this.cropsArea = this.cropsArea.toString().substring(0, 8);
        this.$helper.showTostMessage("", msg, "error");
      }
    },
  },
};
</script>
